import "./i18n";
import "./index.css";

import ReactDOM from "react-dom/client";
import { useTranslation } from "react-i18next";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ThemeProvider from "./components/ThemeProvider";
import TranslationProvider from "./components/TranslationProvider";
import reportWebVitals from "./reportWebVitals.js";
import AddCard from "./screens/addCard.jsx";
import { CardDetails } from "./screens/cardDetails.jsx";
import Faq from "./screens/faq.jsx";
import FitExtendSelector from "./screens/fitExtendSelector.jsx";
import FitSelector from "./screens/fitSelector.jsx";
import FreefitCibus from "./screens/FreefitCibus.jsx";
import MainPage from "./screens/mainPage.jsx";
import { MapPage } from "./screens/map.jsx";
import MultipleEntryPass from "./screens/multipleEntryPass.jsx";
import MultipleEntryPassDetails from "./screens/multipleEntryPassDetails.jsx";
import MultipleEntryPassPurchase from "./screens/multipleEntryPassPurchase.jsx";
import OrderConfirmation from "./screens/orderConfirmation.jsx";
import OrderHistory from "./screens/orderHistory.jsx";
import OtpValidation from "./screens/otpValidation.jsx";
import PartnerError from "./screens/partnerError.jsx";
import Registration from "./screens/registration.jsx";
import RegistrationQuestionnaire from "./screens/registrationQuestionnaire.jsx";
import SelectDateTime from "./screens/selectDateTime.jsx";
import SelectRoomByDate from "./screens/selectRoomByDate.jsx";
import { Summary } from "./screens/summary.jsx";
import UserPhoneValidation from "./screens/userPhoneValidation.jsx";
import Venue from "./screens/venue.jsx";
import HeaderIconBack from "./shared/Header/HeaderIconBack.jsx";
import HeaderIconBurger from "./shared/Header/HeaderIconBurger.jsx";
import HeaderIconClose from "./shared/Header/HeaderIconClose.jsx";
import HeaderNoLogo from "./shared/Header/HeaderNoLogo.jsx";
import HeaderV2 from "./shared/Header/HeaderV2.jsx";
import LayoutV2 from "./shared/LayoutV2.jsx";
import store from "./store/rootStore.js";

const TranslatedHeader = ({ headerKey, ...props }) => {
  const { t } = useTranslation();
  return <HeaderV2 header={t(headerKey)} {...props} />;
};

const TranslatedHeaderNoLogo = ({ headerKey, ...props }) => {
  const { t } = useTranslation();
  return <HeaderNoLogo header={t(headerKey)} {...props} />;
};

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: (
        <LayoutV2>
          <HeaderV2 leftButton={<HeaderIconBurger />} />
          <MainPage />
        </LayoutV2>
      ),
    },
    {
      path: "/roomChoice",
      element: (
        <LayoutV2>
          <TranslatedHeader
            headerKey="WHERE_TO_WORKOUT_TODAY"
            leftButton={<HeaderIconBurger />}
            rightButton={<HeaderIconBack />}
          />
          <FitSelector />
        </LayoutV2>
      ),
    },
    {
      path: "/selectDateTime",
      element: (
        <LayoutV2>
          <TranslatedHeader
            headerKey="WHEN_IS_THE_CLASS"
            leftButton={<HeaderIconClose />}
          />
          <SelectDateTime />
        </LayoutV2>
      ),
    },
    {
      path: "/addCard",
      element: (
        <LayoutV2>
          <TranslatedHeader
            headerKey="CREDIT_CARD_DETAILS"
            leftButton={<HeaderIconBurger />}
            rightButton={<HeaderIconBack />}
          />
          <AddCard />
        </LayoutV2>
      ),
    },
    {
      path: "/orderConfirmation",
      element: (
        <LayoutV2>
          <TranslatedHeader
            headerKey="ORDER_CONFIRMATION"
            leftButton={<HeaderIconClose />}
          />
          <OrderConfirmation />
        </LayoutV2>
      ),
    },
    {
      path: "/orderHistory",
      element: (
        <LayoutV2>
          <TranslatedHeader
            headerKey="ACTIVITY_ORDER"
            leftButton={<HeaderIconBurger />}
            rightButton={<HeaderIconBack />}
          />
          <OrderHistory />
        </LayoutV2>
      ),
    },
    {
      path: "/fitExtendSelector",
      element: (
        <LayoutV2>
          <TranslatedHeader
            headerKey="WHERE_TO_WORKOUT_TODAY"
            leftButton={<HeaderIconBurger />}
            rightButton={<HeaderIconBack />}
          />
          <FitExtendSelector />
        </LayoutV2>
      ),
    },
    {
      path: "/multipleEntryPass",
      element: (
        <LayoutV2>
          <TranslatedHeader
            headerKey="MY_MULTIPLE_ENTRY_PASS"
            leftButton={<HeaderIconBurger />}
            rightButton={<HeaderIconBack />}
          />
          <MultipleEntryPass />
        </LayoutV2>
      ),
    },
    {
      path: "/multipleEntryPassDetails",
      element: (
        <LayoutV2>
          <TranslatedHeader
            headerKey="MULTIPLE_ENTRY_PASS_DETAILS"
            leftButton={<HeaderIconBurger />}
            rightButton={<HeaderIconBack />}
          />
          <MultipleEntryPassDetails />
        </LayoutV2>
      ),
    },
    {
      path: "/multipleEntryPassPurchase",
      element: (
        <LayoutV2>
          <TranslatedHeader
            headerKey="PURCHASE_SUMMARY"
            leftButton={<HeaderIconBurger />}
            rightButton={<HeaderIconBack />}
          />
          <MultipleEntryPassPurchase />
        </LayoutV2>
      ),
    },
    {
      path: "/venue/:recordId",
      element: (
        <LayoutV2>
          <TranslatedHeader
            headerKey="ACTIVITY_ORDER"
            leftButton={<HeaderIconBurger />}
            rightButton={<HeaderIconBack />}
          />
          <Venue />
        </LayoutV2>
      ),
    },
    {
      path: "/selectRoomByDate",
      element: (
        <LayoutV2>
          <TranslatedHeader
            headerKey="ACTIVITY_ORDER"
            leftButton={<HeaderIconBurger />}
            rightButton={<HeaderIconBack />}
          />
          <SelectRoomByDate />
        </LayoutV2>
      ),
    },
    {
      path: "/summary",
      element: (
        <LayoutV2>
          <TranslatedHeader
            headerKey="WHERE_TO_WORKOUT_TODAY"
            leftButton={<HeaderIconBurger />}
            rightButton={<HeaderIconBack />}
          />
          <Summary />
        </LayoutV2>
      ),
    },
    {
      path: "/faq",
      element: (
        <LayoutV2>
          <TranslatedHeader
            headerKey="QUESTIONS_AND_ANSWERS"
            leftButton={<HeaderIconBurger />}
            rightButton={<HeaderIconBack />}
          />
          <Faq />
        </LayoutV2>
      ),
    },
    {
      path: "/registration",
      element: (
        <LayoutV2>
          <Registration />
        </LayoutV2>
      ),
    },
    {
      path: "/registrationQuestionnaire",
      element: (
        <LayoutV2>
          <TranslatedHeader headerKey="HEALTH_DECLARATION_FORM" />
          <RegistrationQuestionnaire />
        </LayoutV2>
      ),
    },
    {
      path: "/map/:latitude/:longitude",
      element: (
        <LayoutV2>
          <HeaderV2 rightButton={<HeaderIconBack />} />
          <MapPage />
        </LayoutV2>
      ),
    },
    {
      path: "/card-details",
      element: (
        <LayoutV2>
          <TranslatedHeaderNoLogo
            headerKey="CREDIT_CARD_DETAILS"
            leftButton={<HeaderIconBurger />}
            rightButton={<HeaderIconBack />}
          />
          <CardDetails />
        </LayoutV2>
      ),
    },
    {
      path: "/phone-validation",
      element: (
        <LayoutV2>
          <UserPhoneValidation />
        </LayoutV2>
      ),
    },
    {
      path: "/otp-validation",
      element: (
        <LayoutV2>
          <OtpValidation />
        </LayoutV2>
      ),
    },
    {
      path: "/Cibus",
      element: <FreefitCibus />,
    },
    {
      path: "/partner-error",
      element: <PartnerError />,
    },
  ],
  {
    basename: "/",
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <TranslationProvider>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </TranslationProvider>
  </Provider>
);

reportWebVitals();
